import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { ActionButtonModule, ListFilterModule, SvgIconModule } from '../../ui-kit';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { DirectivesModule } from '../../common';
import { CountrySelectionComponent } from './country-selection.component';
import { CountrySelectionDialogComponent } from './country-dialog/country-dialog.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { IntrackFeatureModule } from '../../intrack-feature.module';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatChipsModule,
    MatTableModule,
    MatPaginatorModule,
    ListFilterModule,
    NgxMatSelectSearchModule,
    MatCheckboxModule,
    IntrackFeatureModule,
    ActionButtonModule,
    MatDialogModule,
    RouterModule,
    TranslateModule.forChild({}),
    DirectivesModule,
    SvgIconModule,
  ],
  exports: [CountrySelectionComponent, CountrySelectionDialogComponent],
  declarations: [CountrySelectionComponent, CountrySelectionDialogComponent],
})
export class CountrySelectionModule {}
